<template>
  <div>
    <div style="display: flex; flex-direction: row">
      <wrapper-preview-category
        style="max-width: 1250px; background: unset; box-shadow: unset"
      >
        <grid-table
          :headers="parameterCheck"
          :headers-for-rows="parameterCheck2"
          :num-cols="columns"
          :gap="'0'"
          :data-rows="parameterCheck3"
          type-table="grid"
        ></grid-table>
      </wrapper-preview-category>
      <div v-if="parameterCheck3.length > 0" :style="form === '5.19' ?
            'display: flex; flex-direction: column; justify-content: space-between; margin: 135px 0 0 25px;' :
             'display: flex; flex-direction: column; justify-content: space-between; margin: 200px 0 80px 25px;'">
        <img style="width: 76px" :src="require('@/assets/images/Vector_rigth_arrow.svg')" alt=""/>
      </div>
      <wrapper-preview-category
        v-if="parameterCheck3.length > 0" :style="form === '5.19' ?
            'max-width: 350px; margin-left: 30px; margin-top: 0; background: unset; box-shadow: unset; align-self: end;' :
             'max-width: 350px; margin-left: 30px; margin-top: 50px; background: unset; box-shadow: unset; align-self: end;'">
        <grid-table
          :headers="secondTableParameterCheck"
          :headers-for-rows="headersForRows2"
          :num-cols="secondTableColumns"
          :gap="'0'"
          :data-rows="table2"
          type-table="grid"
        >
          <template #no20="{row}">
            <div style="display:flex; flex-direction: column" v-if="row.no20 === '---'">
              <img class="ww-100" :src="require('@/assets/images/brackets/Скобка_general_value_bot.svg')" alt=""/>
              <span style="align-self: center; margin-top: 5px">
                {{ rowOfValues.data[`${valueArrayForTable2[0]}`] }}
              </span>
              <span style="align-self: center; margin-top: 5px; font-weight: 700">{{ arrayForTable2[0] }}</span>
            </div>
            <span style="min-height: 18px" v-else-if="row.no20 === '' && row.no21 === '' && row.no22 === ''"></span>
            <span v-else>{{ $scripts.TableJs.checkValueWithNullAndReturnND(row.no20, 0, 'integer', true, 0) }}</span>
          </template>
          <template #no21="{row}">
            <div style="display:flex; flex-direction: column" v-if="row.no21 === '---'">
              <img class="ww-100" :src="require('@/assets/images/brackets/Скобка_general_value_bot.svg')" alt=""/>
              <span style="align-self: center; margin-top: 5px;">{{
                  rowOfValues.data[`${valueArrayForTable2[1]}`]
                }}</span>
              <span style="align-self: center; margin-top: 5px; font-weight: 700">{{ arrayForTable2[1] }}</span>
            </div>
            <span style="min-height: 18px" v-else-if="row.no20 === '' && row.no21 === '' && row.no22 === ''"></span>
            <span v-else>{{ $scripts.TableJs.checkValueWithNullAndReturnND(row.no21, 0, 'integer', true, 0) }}</span>
          </template>
          <template #no22="{row}">
            <div style="display:flex; flex-direction: column" v-if="row.no22 === '---'">
              <img class="ww-100" :src="require('@/assets/images/brackets/Скобка_general_value_bot.svg')" alt=""/>
              <span style="align-self: center; margin-top: 5px;">{{
                  rowOfValues.data[`${valueArrayForTable2[2]}`]
                }}</span>
              <span style="align-self: center; margin-top: 5px; font-weight: 700">{{ arrayForTable2[2] }}</span>
            </div>
            <span style="min-height: 18px" v-else-if="row.no20 === '' && row.no21 === '' && row.no22 === ''"></span>
            <span v-else>{{ $scripts.TableJs.checkValueWithNullAndReturnND(row.no22, 0, 'integer', true, 0) }}</span>
          </template>
        </grid-table>
      </wrapper-preview-category>
    </div>
    <div v-if="form === '5.13'"
         style="display: flex; flex-direction: column; align-items: flex-end; margin-left: auto; margin-right: 65px; width: 600px; margin-top: -25px;">
      <img style="width: 300px" :src="require('@/assets/images/brackets/Скобка_general_value_bot.svg')" alt=""/>
      <div
        style="display: flex; flex-direction: row; width: 100%; justify-content: center; margin-top: 10px; padding-left: 30px;">
        <span style="margin-right: 25px; color: rgb(128,128,128)">{{ textUnderTable2 }} </span>
        <span> <span style="font-weight: 700">{{
            arrayForTable2[0]
          }}</span> = {{ rowOfValues.data[`${valueArrayForTable2[0]}`] }}</span>
      </div>
    </div>
    <div v-if="form === '5.07'"
         style="display: flex; flex-direction: column; align-items: flex-end; margin-left: auto; width: 1000px; margin-top: -65px;">
      <div style="display: flex; flex-direction: row; width: 100%; justify-content: center; padding-left: 30px;">
        <span style="margin-right: 25px; color: rgb(128,128,128)">{{ textUnderTable2 }} </span>
      </div>
    </div>
  </div>
</template>

<script>
import GridTable from "@/components/GridTable/GridTable";
import WrapperPreviewCategory from "@/components/wrappers/WrapperPreviewCategory";
import config from "@/components/cards/indicatiors/cardsTables/config/m25";

export default {
  name: "doubleFragmentTable",
  components: {GridTable, WrapperPreviewCategory},
  props: {
    item: {
      type: Object
    },
    rowOfValues: {
      type: Object,
      default: () => {
      }
    },
    arrayForTable2: {
      type: Array,
      default: () => []
    },
    valueArrayForTable2: {
      type: Array,
      default: () => []
    },
    textUnderTable2: {
      type: String,
      default: () => '',
    },
    isdpo: {
      type: String,
      default: '0'
    },
    columns: {
      type: Number,
      default: 12,
    },
    secondTableColumns: {
      type: Number,
      default: 3,
    },
    form: {
      type: String,
      default: '0'
    },
    dopInfo: {
      type: String,
      default: ``,
    }
  },
  data() {
    return {
      headers: config,
      table2: [],
      mainTable: [],
      bak: [],
      spec: [],
      mag: [],
      ord: [],
      assist: [],
      dpoArray: [],
    }
  },
  computed: {
    headersForRows2() {
      if (this.form === '5.19') {
        return this.headers.table_2_2.reduce((acc, el) => {
          if (el.variable) {
            acc.push({...el, rows: 1});
          }
          return acc;
        }, [])
      } else {
        return this.headers.table_2.reduce((acc, el) => {
          if (el.variable) {
            acc.push({...el, rows: 1});
          }
          return acc;
        }, [])
      }
    },
    headersForRows3() {
      return this.headers.table_3.reduce((acc, el) => {
        if (el.variable) {
          acc.push({...el, rows: 1});
        }
        return acc;
      }, [])
    },
    headersForRows4() {
      return this.headers.table_4.reduce((acc, el) => {
        if (el.variable) {
          acc.push({...el, rows: 1});
        }
        return acc;
      }, [])
    },
    parameterCheck() {
      if (this.form === '5.19') {
        return this.headers.table_4
      } else {
        return this.headers.table_3
      }
    },
    secondTableParameterCheck() {
      if (this.form === '5.19') {
        return this.headers.table_2_2
      } else {
        return this.headers.table_2
      }
    },
    parameterCheck2() {
      if (this.form === '5.19') {
        return this.headersForRows4
      } else {
        return this.headersForRows3
      }
    },
    parameterCheck3() {
      return this.mainTable
    }
  },
  mounted() {
    this.getTableData();
  },
  methods: {
    getTableData() {
      if (this.form === '5.07') {
        if (this.dopInfo === '') {
          if (this.isdpo == 1){
            this.bak = this.rowOfValues.data.tabB23usl1;
            this.spec = this.rowOfValues.data.tabB23usl2;
            this.mag = this.rowOfValues.data.tabB23usl3;
          } else {
            this.bak = this.rowOfValues.data.tabB23isDpo2.filter(el => el.kcpGroup.usl.id === 1 && el.kcpGroup.ugs.id === 38);
            this.spec = this.rowOfValues.data.tabB23isDpo2.filter(el => el.kcpGroup.usl.id === 2 && el.kcpGroup.ugs.id === 38);
            this.mag = this.rowOfValues.data.tabB23isDpo2.filter(el => el.kcpGroup.usl.id === 3 && el.kcpGroup.ugs.id === 38);
          }

          if (this.bak.length > 0) {
            this.mainTable.push({
              bsm: `Бакалавриат`,
              isUgtxt: true,
              xxx: '',
              nb20: '',
              nb21: '',
              nb22: '',
              nq20: '',
              nq21: '',
              nq22: '',
            })

            this.bak.map(el => {
              return this.mainTable.push({
                ...el,
                bsm: `${el.kcpGroup.code} ${el.kcpGroup.name}`,
                xxx: '...',
                nb20: el.nosgo22,
                nb21: el.nosgv22,
                nb22: el.nosgz22,
                nq20: el.noqgo22,
                nq21: el.noqgv22,
                nq22: el.noqgz22,
              })
            })
          }

          if (this.spec.length > 0) {
            this.mainTable.push({
              bsm: `Специалитет`,
              isUgtxt: true,
              xxx: '',
              nb20: '',
              nb21: '',
              nb22: '',
              nq20: '',
              nq21: '',
              nq22: '',
            })

            this.spec.map(el => {
              return this.mainTable.push({
                ...el,
                bsm: `${el.kcpGroup.code} ${el.kcpGroup.name}`,
                xxx: '...',
                nb20: el.nosgo22,
                nb21: el.nosgv22,
                nb22: el.nosgz22,
                nq20: el.noqgo22,
                nq21: el.noqgv22,
                nq22: el.noqgz22,
              })
            })
          }

          if (this.mag.length > 0) {
            this.mainTable.push({
              bsm: `Магистратура`,
              isUgtxt: true,
              xxx: '',
              nb20: '',
              nb21: '',
              nb22: '',
              nq20: '',
              nq21: '',
              nq22: '',
            })

            this.mag.map(el => {
              return this.mainTable.push({
                ...el,
                bsm: `${el.kcpGroup.code} ${el.kcpGroup.name}`,
                xxx: '...',
                nb20: el.nosgo22,
                nb21: el.nosgv22,
                nb22: el.nosgz22,
                nq20: el.noqgo22,
                nq21: el.noqgv22,
                nq22: el.noqgz22,
              })
            })
          }
        } else if (this.dopInfo === 'okvedO' || this.dopInfo === 'okvedM') {
          this.bak = this.rowOfValues.data.tabB23isDpo2.filter(el => el.kcpGroup.usl.id === 1 && (this.dopInfo === 'okvedO' && (el.kcpGroup.ugs.id === 38 || el.kcpGroup.ugs.id === 40) || this.dopInfo === 'okvedM'));
          this.spec = this.rowOfValues.data.tabB23isDpo2.filter(el => el.kcpGroup.usl.id === 2 && (this.dopInfo === 'okvedO' && (el.kcpGroup.ugs.id === 38 || el.kcpGroup.ugs.id === 40) || this.dopInfo === 'okvedM'));
          this.mag = this.rowOfValues.data.tabB23isDpo2.filter(el => el.kcpGroup.usl.id === 3 && (this.dopInfo === 'okvedO' && (el.kcpGroup.ugs.id === 38 || el.kcpGroup.ugs.id === 40) || this.dopInfo === 'okvedM'));

          if (this.bak.length > 0) {
            this.mainTable.push({
              bsm: `Бакалавриат`,
              isUgtxt: true,
              xxx: '',
              nb20: '',
              nb21: '',
              nb22: '',
              nq20: '',
              nq21: '',
              nq22: '',
            })

            this.bak.map(el => {
              return this.mainTable.push({
                bsm: `${el.kcpGroup.code} ${el.ugtxt}`,
                xxx: '...',
                nb20: el.nosgo22,
                nb21: el.nosgv22,
                nb22: el.nosgz22,
                nq20: el.noqgo22,
                nq21: el.noqgv22,
                nq22: el.noqgz22,
              })
            })
          }

          if (this.spec.length > 0) {
            this.mainTable.push({
              bsm: `Специалитет`,
              isUgtxt: true,
              xxx: '',
              nb20: '',
              nb21: '',
              nb22: '',
              nq20: '',
              nq21: '',
              nq22: '',
            })

            this.spec.map(el => {
              return this.mainTable.push({
                ...el,
                bsm: `${el.kcpGroup.code} ${el.ugtxt}`,
                xxx: '...',
                nb20: el.nosgo22,
                nb21: el.nosgv22,
                nb22: el.nosgz22,
                nq20: el.noqgo22,
                nq21: el.noqgv22,
                nq22: el.noqgz22,
              })
            })
          }

          if (this.mag.length > 0) {
            this.mainTable.push({
              bsm: `Магистратура`,
              isUgtxt: true,
              xxx: '',
              nb20: '',
              nb21: '',
              nb22: '',
              nq20: '',
              nq21: '',
              nq22: '',
            })

            this.mag.map(el => {
              return this.mainTable.push({
                ...el,
                bsm: `${el.kcpGroup.code} ${el.ugtxt}`,
                xxx: '...',
                nb20: el.nosgo22,
                nb21: el.nosgv22,
                nb22: el.nosgz22,
                nq20: el.noqgo22,
                nq21: el.noqgv22,
                nq22: el.noqgz22,
              })
            })
          }
        }
      } else if (this.form === '5.13') {
        if (this.isdpo == 1){
          this.ord = this.rowOfValues.data.tabB23usl9;
          this.assist = this.rowOfValues.data.tabB23usl12;
        } else {
          this.ord = this.rowOfValues.data.tabB23isDpo2.filter(el => el.kcpGroup.usl.id === 9);
          this.assist = this.rowOfValues.data.tabB23isDpo2.filter(el => el.kcpGroup.usl.id === 12);
        }

        if (this.ord.length > 0) {
          this.mainTable.push({
            bsm: `Ординатура`,
            isUgtxt: true,
            xxx: '',
            nb20: '',
            nb21: '',
            nb22: '',
            nq20: '',
            nq21: '',
            nq22: '',
          })

          this.ord.map(el => {
            return this.mainTable.push({
              ...el,
              bsm: `${el.kcpGroup.code} ${el.kcpGroup.name}`,
              xxx: '...',
              nb20: el.nosgo22,
              nb21: el.nosgv22,
              nb22: el.nosgz22,
              nq20: el.noqgo22,
              nq21: el.noqgv22,
              nq22: el.noqgz22,
            })
          })
        }

        if (this.assist.length > 0) {
          this.mainTable.push({
            bsm: `Ассистентура-стажировка`,
            isUgtxt: true,
            xxx: '',
            nb20: '',
            nb21: '',
            nb22: '',
            nq20: '',
            nq21: '',
            nq22: '',
          })

          this.assist.map(el => {
            return this.mainTable.push({
              ...el,
              bsm: `${el.kcpGroup.code} ${el.kcpGroup.name}`,
              xxx: '...',
              nb20: el.nosgo22,
              nb21: el.nosgv22,
              nb22: el.nosgz22,
              nq20: el.noqgo22,
              nq21: el.noqgv22,
              nq22: el.noqgz22,
            })
          })
        }
      } else if (this.form === '5.19' && (this.rowOfValues.data.tabB23dpo?.txdpo22 || this.rowOfValues.data.tabB23isDpo2Dpo)) {
        if (this.isdpo == 1){
          this.dpoArray = [this.rowOfValues.data.tabB23dpo];
        } else {
          if (this.dopInfo === ``) {
            this.dpoArray = this.rowOfValues.data.tabB23isDpo2Dpo.filter(el => el.txdpo22.slice(0, 1) === 'K' || el.txdpo22.slice(0, 1) === 'N' || el.txdpo22.slice(0, 1) === 'G');
          } else if (this.dopInfo === `okvedO`) {
            this.dpoArray = this.rowOfValues.data.tabB23isDpo2Dpo.filter(el => el.txdpo22.slice(0, 1) === 'O');
          } else if (this.dopInfo === `okvedM`) {
            this.dpoArray = this.rowOfValues.data.tabB23isDpo2Dpo.filter(el => el.txdpo22.slice(0, 1) === 'M');
          }
        }

        // tabB23dpo.txdpo22 ? в === 1

        if (this.dpoArray.length > 0) {
          this.dpoArray.map(el => {
            return this.mainTable.push({
              bsm: el?.txdpo22,
              xxx: '...',
              nb20: el?.nvpks21,
              nb21: el?.nvpkv21,
              nb22: el?.nvpkz21,
              nq20: el?.nvpps21,
              nq21: el?.nvppv21,
              nq22: el?.nvppz21,
            })
          })
        }
        // else {
        //   this.mainTable.push({
        //     bsm: `${this.rowOfValues.data.ugorg.slice(0, 8)} ${this.rowOfValues.data.txdpo23}`,
        //     xxx: '...',
        //     nb20: this.rowOfValues.data.nvpks22,
        //     nb21: this.rowOfValues.data.nvpkv22,
        //     nb22: this.rowOfValues.data.nvpkz22,
        //     nq20: this.rowOfValues.data.nvppo22,
        //     nq21: this.rowOfValues.data.nvppv22,
        //     nq22: this.rowOfValues.data.nvppz22,
        //   })
        // }
      }

      ////////////////   table2    /////////////////////

      if (this.form === '5.07') {
        if (this.dopInfo === ``) {
          for (let i = 0; i < this.bak.length; i++) {
            this.table2.push({
              no20: this.bak[i].nougo22,
              no21: this.bak[i].nougv22,
              no22: this.bak[i].nougz22,
            })
          }
          if (this.spec.length > 0) {
            this.table2.push({
              no20: ``,
              no21: ``,
              no22: ``,
            })
          }
          for (let j = 0; j < this.spec.length; j++) {
            this.table2.push({
              no20: this.spec[j].nougo22,
              no21: this.spec[j].nougv22,
              no22: this.spec[j].nougz22,
            })
          }
          if (this.mag.length > 0) {
            this.table2.push({
              no20: ``,
              no21: ``,
              no22: ``,
            })
          }
          for (let k = 0; k < this.mag.length; k++) {
            this.table2.push({
              no20: this.mag[k].nougo22,
              no21: this.mag[k].nougv22,
              no22: this.mag[k].nougz22,
            })
          }
        } else if (this.dopInfo === 'okvedO' || this.dopInfo === 'okvedM') {
          for (let i = 0; i < this.bak.length; i++) {
            this.table2.push({
              no20: this.bak[i].nougo22,
              no21: this.bak[i].nougv22,
              no22: this.bak[i].nougz22,
            })
          }
          if (this.spec.length > 0) {
            this.table2.push({
              no20: ``,
              no21: ``,
              no22: ``,
            })
          }
          for (let j = 0; j < this.spec.length; j++) {
            this.table2.push({
              no20: this.spec[j].nougo22,
              no21: this.spec[j].nougv22,
              no22: this.spec[j].nougz22,
            })
          }
          if (this.mag.length > 0) {
            this.table2.push({
              no20: ``,
              no21: ``,
              no22: ``,
            })
          }
          for (let k = 0; k < this.mag.length; k++) {
            this.table2.push({
              no20: this.mag[k].nougo22,
              no21: this.mag[k].nougv22,
              no22: this.mag[k].nougz22,
            })
          }
        }
        this.table2.push({
          bsm: '',
          no20: '---',
          no21: '---',
          no22: '---',
        })
      } else if (this.form === '5.13') {
        for (let i = 0; i < this.ord.length; i++) {
          this.table2.push({
            no20: this.ord[i].nougo22,
            no21: this.ord[i].nougv22,
            no22: this.ord[i].nougz22,
          })
        }
        if (this.assist.length > 0) {
          this.table2.push({
            no20: ``,
            no21: ``,
            no22: ``,
          })
        }
        for (let j = 0; j < this.assist.length; j++) {
          this.table2.push({
            no20: this.assist[j].nougo22,
            no21: this.assist[j].nougv22,
            no22: this.assist[j].nougz22,
          })
        }
      } else if (this.form === '5.19') {
        if (this.isdpo == 2) {
          this.dpoArray.map((el) => {
            return this.table2.push({
              no20: el.nvpko21,
              no21: el.nvppo21,
            })
          })
        } else {
          this.table2 = [
            {
              no20: this.rowOfValues.data.nvpko22,
              no21: this.rowOfValues.data.nvppo22,
            },
          ];
        }
        this.table2.push({
          bsm: '',
          no20: '---',
          no21: '---',
        })
      }
    }
  }
}
</script>

<style lang="sass" scoped>

</style>